<template>
  <div class="Echarts">
    <div
      :id="domId"
      style="background: #ffffff; border-radius: 5px; margin-left: 1em;"
    ></div>
  </div>
</template>

<script>
export default {
  name: "Echarts",
  props: {
    domId: {
      type: String
    },
    unit: {
      type: String
    },
    chartsType: {
      type: String
    },
    width: {
      type: String
    },
    height: {
      type: String
    },
    titleData: {
      type: String
    },
    seriesData: {
      type: Array,
      default() {
        return [];
      }
    },
    xAxisData: {
      type: Array,
      default() {
        return [];
      }
    },
    legendData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      sEcharts: {},
      option: {}
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      this.initCharts();
    });
  },
  computed: {},
  watch: {},
  methods: {
    initCharts() {
      let sEchartsDom = document.getElementById(this.domId);
      sEchartsDom.style.width = this.width;
      sEchartsDom.style.height = this.height;
      this.sEcharts = this.$echarts.init(sEchartsDom);
      this.option = {
        title: {
          text: this.titleData
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: this.legendData,
          bottom: 0 // 将图例固定在底部
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "12%",
          top: "5%",
          containLabel: true
        },
        toolbox: {},
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xAxisData
        },
        yAxis: {
          type: "value",
          min: function(value) {
            // 动态计算最小值（如向下取整或留出间距）
            return Math.floor(value.min * 0.9); // 示例：最小值减少10%空间
          },
          max: function(value) {
            // 动态计算最大值（如向上取整）
            return Math.ceil(value.max * 1.1); // 示例：最大值增加10%空间
          }
        },
        series: this.seriesData
      };

      this.sEcharts.setOption(this.option);
    },
    freshOption(_seriesData, _xAxisData, _legendData) {
      this.option.legend.data = _legendData;
      this.option.xAxis.data = _xAxisData;
      this.option.series = _seriesData;
      this.sEcharts.clear();
      this.sEcharts.setOption(this.option);
      this.sEcharts.resize();
    }
  }
};
</script>

<style scoped lang="less"></style>
<style></style>



// WEBPACK FOOTER //
// src/views/BMS/deviceManagement/deviceEcharts.vue